import {
  multi,
  number,
  OTHER,
  option,
  text,
  type UsWorksheetDefinition,
} from "../us-fields";

export const US_SOFT_TISSUE: UsWorksheetDefinition = {
  examType: "us_soft_tissue",
  version: 1,
  indications: [
    option("erythema", "Erythema"),
    option("pain", "Pain"),
    option("swelling", "Swelling"),
    option("fluctuance", "Fluctuance"),
    option("suspected_foreign_body", "Suspected foreign body"),
  ],
  sections: [
    {
      id: "soft_tissue_location",
      label: "Soft tissue location",
      role: "findings",
      beforeIndication: true,
      fields: [text("soft_tissue.location", "Soft tissue location")],
    },
    {
      id: "soft_tissue_findings",
      label: "Findings",
      role: "findings",
      technicallyLimited: true,
      fields: [
        multi("soft_tissue.findings", "Findings", [
          option("no_abnormality", "No soft tissue abnormality"),
          option("abscess", "Abscess", {
            reveals: [
              number("soft_tissue.abscess_size", "Abscess, size", "cm"),
            ],
          }),
          option("cobblestoning", "Cobblestoning"),
          option("soft_tissue_gas", "Soft tissue gas"),
          option("foreign_body", "Foreign body"),
          option("superficial_vein_thrombus", "Superficial vein thrombus", {
            reveals: [
              text(
                "soft_tissue.thrombus_vein",
                "Superficial vein thrombus in vein",
              ),
            ],
          }),
          OTHER,
        ]),
      ],
    },
    {
      id: "soft_tissue_impression",
      label: "Impression",
      role: "impression",
      fields: [
        multi("soft_tissue.impression", "Impression", [
          option("normal_soft_tissue", "Normal focused soft tissue ultrasound"),
          option("abscess", "Abscess"),
          option("soft_tissue_edema", "Soft tissue edema"),
          option("soft_tissue_gas", "Soft tissue gas"),
          option("foreign_body", "Foreign body"),
          option("superficial_vein_thrombus", "Superficial vein thrombus"),
          OTHER,
          option("indeterminate", "indeterminate"),
        ]),
      ],
    },
  ],
  normalImpressions: [
    { sectionId: "soft_tissue_impression", value: "normal_soft_tissue" },
  ],
  billing: {
    codes: [
      { cpt: "76536", label: "Head and neck" },
      { cpt: "76882", label: "Extremities (non-vascular)" },
      { cpt: "76604", label: "Chest wall" },
      { cpt: "76705", label: "Abdominal wall or lower back" },
      { cpt: "76857", label: "Pelvic Wall (non-obstetric)" },
    ],
  },
};
